import { render, staticRenderFns } from "./CashCustomsReport.vue?vue&type=template&id=01e8ad78&scoped=true&"
import script from "./CashCustomsReport.vue?vue&type=script&lang=js&"
export * from "./CashCustomsReport.vue?vue&type=script&lang=js&"
import style0 from "./CashCustomsReport.vue?vue&type=style&index=0&id=01e8ad78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e8ad78",
  null
  
)

export default component.exports